import React, { useState } from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Icon,
} from "@chakra-ui/react";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";

import TablePagination from "../../../../components/TablePagination";

const TableEquipe = (props) => {
  const { data, columns, removePagination } = props;

  const [nItens] = useState(removePagination ? 99999999 : 10);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    canPreviousPage,
    canNextPage,
    gotoPage,
    pageOptions,
    page,
    pageCount,
    nextPage,
    previousPage,
    setPageSize,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        pageSize: nItens,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect
  );

  function irParaPagina(pagina) {
    gotoPage(pagina);
  }

  function selecionarTotalItens(nItens) {
    setPageSize(nItens);
  }

  return (
    <Flex flexDir="column" w="100%">
      <Flex flexDir="column" width="100%" mt="20px" h="100%">
        <Flex flexDir={"column"}>
          <Flex overflowX="auto" pb={5}>
            <Table {...getTableProps} backgroundColor="white">
              <Thead backgroundColor="#ECEFF1">
                {headerGroups.map((headerGroup, index) => (
                  <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                    {headerGroup.headers.map((column, index) => (
                      <Th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps({ title: undefined })
                        )}
                        key={index}
                        textAlign={
                          column.Header === "Opções" ? "center" : "start"
                        }
                        p="0px">
                        <Flex flexDir="row" alignContent="center" pl={"2"}>
                          <Text as="p">{column.render("Header")}</Text>
                          {column.Header !== "Opções" ? (
                            <Flex pl={1} alignItems="center">
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <Icon as={FaSortDown} boxSize="14px" />
                                ) : (
                                  <Icon as={FaSortUp} boxSize="14px" />
                                )
                              ) : (
                                <Icon as={FaSort} boxSize="14px" />
                              )}
                            </Flex>
                          ) : (
                            ""
                          )}
                        </Flex>
                      </Th>
                    ))}
                  </Tr>
                ))}
              </Thead>
              <Tbody {...getTableBodyProps}>
                {page.map((row, i) => {
                  prepareRow(row);

                  return (
                    <Tr
                      {...row.getRowProps()}
                      key={i}
                      borderBottom="solid 5px #DDEBEA">
                      {row.cells.map((cell, index) => {
                        if (
                          cell.column.Header === "Validade do termo de Guarda"
                        ) {
                          return (
                            <Td
                              pb="2"
                              pl="1"
                              w={"13%"}
                              fontWeight={400}
                              fontSize="13px"
                              lineHeight="21.6px"
                              {...cell.getCellProps()}
                              key={index}>
                              {cell.render("Cell")}
                            </Td>
                          );
                        }
                        return (
                          <Td
                            pb="2"
                            pl="1"
                            fontWeight={400}
                            fontSize="13px"
                            lineHeight="21.6px"
                            {...cell.getCellProps()}
                            key={index}>
                            {cell.render("Cell")}
                          </Td>
                        );
                      })}
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </Flex>
          {!removePagination && (
            <TablePagination
              nItens={nItens}
              selecionarTotalItens={selecionarTotalItens}
              irParaPagina={irParaPagina}
              pageSize={state.pageSize}
              setPageSize={setPageSize}
              rows={rows}
              gotoPage={gotoPage}
              canPreviousPage={canPreviousPage}
              previousPage={previousPage}
              pageOptions={pageOptions}
              pageIndex={state.pageIndex}
              canNextPage={canNextPage}
              nextPage={nextPage}
              pageCount={pageCount}
            />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default TableEquipe;
